module.exports = __webpack_public_path__ + "img/canada-cerebrovascular-disease-female.ffd4ccb8.png";